import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { PhxDragItemComponent } from '../base/phx-drag-item.component';

@Component({
  selector: 'phx-drag-item-card',
  templateUrl: './phx-drag-item-card.component.html',
  styleUrls: ['./phx-drag-item-card.component.scss', '../base/phx-drag-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-drag-item phx-drag-item-card',
    '[class.phx-drag-item-no-handle]': '!hasDragHandle && !isViewMode',
    '[class.phx-drag-item-whole-card]': 'phxWholeCardDraggable && !isViewMode',
  },
  providers: [{ provide: PhxDragItemComponent, useExisting: PhxDragItemCardComponent }],
})
export class PhxDragItemCardComponent extends PhxDragItemComponent {
  @Input() phxWholeCardDraggable: boolean = false;
}
